import { AbstractControl, FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { retryWithBackOff } from 'src/app/helpers/retry.operators';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';

export class LpMustNotBeBannedInProperty {

    static valid(vehicleService: VehicleService, system: string, location: string) {

        return (control: AbstractControl) => {

          return vehicleService.checkIfLpIsBannedInProperty(control.value, system, location).pipe(
            retryWithBackOff(1000),
            map(res => {
              if (!res) {
                return null;
              }
              return res.is_not_blacklisted ? null : {
                blackListedInProperty: true,
                message: res.message || null,
                citation_number: res.citation_number || null
              };

          }));

        };

    }

    static validate(vehicleService: VehicleService, controlName: string, system: string, location: string) {

        return (formGroup: FormGroup) => {

            const control = formGroup.controls[controlName];

            if (control.errors && !control.errors.invalid) {
              return;
            }

            vehicleService.checkIfLpIsBannedInProperty(control.value, system, location).pipe(
              retryWithBackOff(1000),
              map(res => {
                if (!res) {
                  return;
                }

                if (res.is_not_blacklisted) {
                  control.setErrors(null);
                } else {
                  control.setErrors({
                    blackListedInProperty: true,
                    message: res.message || null,
                    citation_number: res.citation_number || null
                  });
                }
            }));
        };
    }
}